import { render } from "./Validate.vue?vue&type=template&id=4bf328f2&scoped=true"
import script from "./Validate.vue?vue&type=script&lang=js"
export * from "./Validate.vue?vue&type=script&lang=js"

import "./Validate.vue?vue&type=style&index=0&id=4bf328f2&scoped=true&lang=css"

import exportComponent from "D:\\图书管理系统VUE\\Vue-Springboot-Library\\vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bf328f2"]])

export default __exports__